module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "icon_standings_bracket-gray.42468b09.svg";